import angular from 'angular';
import '../core.module';

export const EVENTS = {
  THEME_CHANGED: 'THEME_CHANGED',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  NOTIFICATION_PUSHED: 'NOTIFICATION_PUSHED',
  SIDEBAR_TOGGLED: 'SIDEBAR_TOGGLED'
};

angular.module('app.core').constant('EVENTS', EVENTS);
